import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
  TimelineSeparator,
} from "@mui/lab";
import { Card } from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import Loading from "../../../components/loading/loading";
import useViewModel from "./ViewModel";

export function TransactionHistoryModal(): JSX.Element {
  const {
    data: { listHistory, loadingActive, longestDate },
    method: { onGetHistory },
  } = useViewModel();
  const { id } = useParams();

  useEffect(() => {
    onGetHistory(id!);
  }, []);

  return (
    <Card
      style={{
        marginTop: "-1rem",
        borderRadius: "0.375rem",
        paddingTop: "3rem",
        paddingBottom: "1rem",
      }}
    >
      <Timeline
        nonce={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        sx={{
          p: 0,
          mb: "-2rem",
          mt: "-2rem",
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.5,
          },
        }}
      >
        <TimelineItem>
          <TimelineOppositeContent
            style={{
              display: "flex",
              maxWidth: `${listHistory.length > 0 ? longestDate + 3.3 : 10}ch`,
              fontWeight: "bold",
              paddingTop: "0.6rem",
            }}
          >
            Date
          </TimelineOppositeContent>
          <TimelineSeparator
            style={{
              height: "3rem",
              fontWeight: "bold",
              fontSize: "x-large",
            }}
          >
            <div>|</div>
          </TimelineSeparator>
          <TimelineOppositeContent
            style={{
              display: "flex",
              maxWidth: "6.2rem",
              fontWeight: "bold",
              paddingTop: "0.6rem",
              marginLeft: "0.8ch",
              marginRight: "0.8ch",
            }}
          >
            Time
          </TimelineOppositeContent>
          <TimelineSeparator
            style={{
              height: "3rem",
              fontWeight: "bold",
              fontSize: "x-large",
            }}
          >
            <div>|</div>
          </TimelineSeparator>
          <TimelineContent
            style={{
              fontWeight: "bold",
              paddingTop: "0.6rem",
              marginLeft: "0.8ch",
            }}
          >
            Action
          </TimelineContent>
        </TimelineItem>
      </Timeline>
      {listHistory.map((data, index) => (
        <Timeline
          nonce={undefined}
          onResize={undefined}
          onResizeCapture={undefined}
          sx={{
            p: 0,
            mb: "-2rem",
            mt: "-2rem",
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 0.5,
            },
          }}
        >
          <TimelineItem>
            <TimelineOppositeContent
              style={{ display: "flex", maxWidth: `${longestDate + 3}ch` }}
            >
              {moment(data.dateIn).format("MMMM DD, YYYY")}
            </TimelineOppositeContent>
            <TimelineSeparator style={{ height: "3rem", marginTop: "0.75rem" }}>
              <TimelineDot
                color="primary"
                variant="filled"
                style={{ margin: 0 }}
              />
              {index + 1 < listHistory.length && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineOppositeContent
              style={{
                display: "flex",
                maxWidth: "6rem",
                marginLeft: "0.8ch",
                marginRight: "0.8ch",
              }}
            >
              {moment(data.dateIn).format("HH:mm:ss")}
            </TimelineOppositeContent>
            <TimelineSeparator style={{ height: "3rem", marginTop: "0.75rem" }}>
              <TimelineDot
                color="primary"
                variant="filled"
                style={{ margin: 0 }}
              />
              {index + 1 < listHistory.length && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ marginLeft: "0.8ch" }}>
              {data.description}
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      ))}
      <Loading open={loadingActive} />
    </Card>
  );
}
